import { useMemo } from 'react';
import { useImportState } from '../contexts/import_state.context';
export const useStepStates = ({ documentType, cloneCheckStatus }) => {
    const { files, localeMap, isFilesLoading } = useImportState();
    return useMemo(() => {
        const filesEntries = Object.entries(files);
        if (documentType === 'NON_MEDABLE_FORMAT') {
            return [
                { isEnabled: true }, // Step 1: Document type selection
                {
                    isEnabled: Boolean(filesEntries.length && filesEntries.every(([, { status }]) => status === 'success') && !isFilesLoading),
                }, // Step 2: File upload - enabled when files are uploaded successfully and not loading
                {
                    isEnabled: Boolean(filesEntries.length && filesEntries.every(([id]) => id in localeMap) && !isFilesLoading),
                }, // Step 3: Locale selection - enabled when all files have locales selected and not loading
            ];
        }
        if (documentType === 'MEDABLE_FORMAT_EXISTING_CLONE' || documentType === 'MEDABLE_FORMAT_EXISTING_VERSION') {
            return [{ isEnabled: true }, { isEnabled: cloneCheckStatus }];
        }
        if (documentType === 'MEDABLE_FORMAT') {
            return [{ isEnabled: true }, { isEnabled: !isFilesLoading }];
        }
        return [{ isEnabled: documentType !== undefined }, { isEnabled: true }];
    }, [files, localeMap, documentType, cloneCheckStatus, isFilesLoading]);
};
